import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import environment from "environments/environment.js"

const mutation = graphql`
    mutation toggleEmailsMutation($input: toggleHyeventEmailsInput!){
        toggleHyeventEmails(input:$input) {
          hyevent{
            id
            thankYouCampaignId
            enableThankYouEmail
            enableCancelEmail
            enableFollowUpEmail
            enableInviteEmail
            enableMorningReminderEmail
            enableNightReminderEmail
            enableRescheduleEmail
            enableRsvpCancelledEmail
            enableRsvpedEmail
            enableWaitlistOpeningEmail
            enableWaitlistedEmail
          }
        }
    }
`;

function commit(input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;